import { Box, Typography } from '@mui/material'
import PrimaryButton from '../common/PrimaryButton'
import { leadershipHero } from '../../data/leadershipContent'
import { mobilePaddingX, mobileSectionPy, mobileSectionTitleSx, mobileBodyTextSx, MOBILE_MQ } from '../../theme/mobileLayout'

export default function LeadershipHeroSection() {
  return (
    <Box
      component="section"
      sx={{
        width: '100%',
        maxWidth: 1920,
        mx: 'auto',
        px: mobilePaddingX,
        pt: { ...mobileSectionPy, md: '120px', lg: '260px' },
        pb: { ...mobileSectionPy, lg: '80px' },
        boxSizing: 'border-box',
        bgcolor: '#fffefa',
      }}
    >
      <Box
        sx={{
          maxWidth: 1520,
          mx: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
          textAlign: 'center',
        }}
      >
        <Typography
          component="h1"
          sx={{
            fontSize: { ...mobileSectionTitleSx.fontSize, lg: 80 },
            [MOBILE_MQ]: { fontSize: 28 },
            lineHeight: 'normal',
            fontWeight: 400,
            color: '#111',
          }}
        >
          {leadershipHero.title}
        </Typography>
        <Typography
          sx={{
            fontSize: mobileBodyTextSx.fontSize,
            lineHeight: 'normal',
            fontWeight: 400,
            color: '#111',
            maxWidth: 1520,
          }}
        >
          {leadershipHero.subtitle}
        </Typography>
        <PrimaryButton to="/contact" sx={{ mt: { xs: 1, lg: 0 } }}>
          {leadershipHero.cta}
        </PrimaryButton>
      </Box>
    </Box>
  )
}
